// extracted by mini-css-extract-plugin
export default {"CDTIFrameWrapper":"designView-module_CDTIFrameWrapper_j9DWD","CDTIFrame":"designView-module_CDTIFrame_AIQUt"};